module.exports = __webpack_public_path__ + "media/goback.54aac0c3.svg";